import React from "react";
import PropTypes from "prop-types";

export const SummaryItemComponent = (props) => (
  <span>
    <div className="title">
      <h1>{props.itemKey}</h1>
    </div>
    <div className="section-body">{props.children}</div>
  </span>
);

export default SummaryItemComponent;

SummaryItemComponent.propTypes = {
  itemKey: PropTypes.string,
  children: PropTypes.any,
};
